var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-section',{attrs:{"id":"features","gap":"xl","gutter-y":"medium","gutter-x":"","contain":""}},[_c('SectionHeader',{attrs:{"title":_vm.$t('shop.featuresTitle'),"description":_vm.$t('shop.featuresDescription'),"text-align":"center"}}),_vm._v(" "),_c('ShopFeaturesTabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }